export default __webpack_public_path__ + "static/media/r6s_logo_jp.0cb1823e.png";